<template>
  <div>
    <article class="medicine-status clearfix">
        <p class="tips" v-if="!img">正在加载中...</p>
        <img :src="img" loading="lazy">
    </article>
  </div>
</template>
<script>
export default {
  name: "proGramme",
  data() {
    return {}
  },
  props:['img','name'],
  mounted() {
  document.onkeydown = function (e) {
    if (e && e.keyCode === 123) {
      e.returnValue = false
      // e.keyCode = 0   //去掉也可以的，倘若要写，则需要setter 以及 getter配合使用，不配合，会报错
      return false
    }
  }
  document.body.onselectstart =
      document.body.oncontextmenu =
      function () {
          return false; //取消浏览器默认操作
    };
  },
  methods: {},
}
</script>
<style lang="stylus" scoped>
div {
  color: #333333;
  overflow-x: auto;
}

.clearfix:before, .clearfix:after {
  content: '';
  display: table;
  clear: both;
}

.tips{
  font-size:28px;
  margin-top:120px;
  color:#999999;
}

.medicine-status {
  min-width: calc(1440px * var(--proportion));
  margin: 0 auto 50px auto;
  padding: 0  calc(40px * var(--proportion));
  text-align: center;

  .status-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .status-top p{
    font-size:18px;
    margin: 50px auto 50px auto;
  }

  .status-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .status-text {
    display: inline-block;
    font-size: 18px;
    margin-top: 20px;
  }

  .status-content {
    justify-content: center;
    align-items: center;
    justify-items: center;
    margin-top: 34px;

    .content {
      width: 233px;
      height: 274px;
      float: left;
      margin-top: 24px;
      border: 1px solid #F5F5F5;
      box-sizing: border-box;

      .content-top {
        margin-top: 68px;
      }

      .content-center {
        font-size: 18px;
        margin-top: 36px;
        font-weight: bold;
        line-height: 28px;
        padding: 0 60px;
      }
    }

    .content:nth-child(3), .content:nth-child(6) {
      .content-center {
        padding: 0 45px;
      }
    }

    .content:hover {
      box-shadow: 0px 10px 25px 1px rgba(185, 185, 185, 0.15);
    }
  }
}

.medicine-pain {
  width: 1400px;
  margin: 80px auto;
  text-align: center;

  .pain-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .pain-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .pain-text {
    display: inline-block;
    font-size: 18px;
    margin-top: 20px;
  }

  .pain-content {
    width: 1400px;
    margin-top: 60px;

    .content-top {
      height: 186px;
      position: relative;
      border-bottom: 1px solid #F4F4F4;

      .text {
        padding: 21px 25px;
        width: 100%;
        height: 130px;
        font-size: 14px;
        line-height: 28px;
        box-sizing: border-box;
        text-align: left;
        text-align-last: center;
      }

      .img {
        position: absolute;
        top: 110px;
        width: 270px;
        height: 48px;
        font-size: 18px;
        font-weight: bold;
        line-height: 40px;
        background-image: url('../../static/images/fresh/ds.png');
      }

      .b-yuan {
        position: absolute;
        top: 176px;
        left: 125px;
        width: 20px;
        height: 20px;
        background: #F4F4F4;
        border-radius: 50%;
        box-sizing: border-box;
        padding: 5px;

        .s-yuan {
          width: 10px;
          height: 10px;
          background: #CCCCCC;
          border-radius: 50%;
        }
      }

      .top-left, .top-center, .top-right {
        width: 270px;
        height: 150px;
        float: left;
        box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
        border-radius: 7px;
      }

      .top-center {
        margin-left: 295px;

        .text {
          padding: 34px 57px;
        }

        .b-yuan {
          left: 690px;
        }
      }

      .top-right {
        margin-left: 295px;

        .text {
          padding: 34px 34px;
        }

        .b-yuan {
          left: 1260px;
        }
      }

      .top-left:hover, .top-center:hover, .top-right:hover {
        .img {
          background-image: url('../../static/images/fresh/dsh.png');
        }

        .b-yuan {
          background: #FFF9E5;

          .s-yuan {
            background: #FFC000;
          }
        }
      }
    }

    .content-bottom {
      height: 186px;
      position: relative;

      .text {
        padding: 66px 36px;
        width: 100%;
        height: 130px;
        font-size: 14px;
        line-height: 28px;
        box-sizing: border-box;
        text-align: left;
        text-align-last: center;
      }

      .img {
        position: absolute;
        top: 26px;
        width: 270px;
        height: 48px;
        font-size: 18px;
        font-weight: bold;
        line-height: 55px;
        background-image: url('../../static/images/fresh/sds.png');
      }

      .b-yuan {
        position: absolute;
        top: -10px;
        left: 408px;
        width: 20px;
        height: 20px;
        background: #F4F4F4;
        border-radius: 50%;
        box-sizing: border-box;
        padding: 5px;

        .s-yuan {
          width: 10px;
          height: 10px;
          background: #CCCCCC;
          border-radius: 50%;
        }
      }

      .bottom-left, .bottom-right {
        width: 270px;
        height: 150px;
        float: left;
        margin-left: 283px;
        margin-top: 34px;
        box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
        border-radius: 7px;
      }

      .bottom-right {
        margin-left: 295px;

        .b-yuan {
          left: 973px;
        }
      }

      .bottom-left:hover, .bottom-right:hover {
        .img {
          background-image: url('../../static/images/fresh/sh.png');
        }

        .b-yuan {
          background: #FFF9E5;

          .s-yuan {
            background: #FFC000;
          }
        }
      }
    }
  }
}

.medicine-system {
  width: 1443px;
  margin: 0 auto;
  text-align: center;

  .system-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .system-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .system-text {
    display: inline-block;
    font-size: 18px;
    margin-top: 20px;
  }

  .system-content {
    width: 1400px;
    height: 867px;
    margin-top: 57px;
  }
}

.medicine-function {
  width: 1443px;
  margin: 80px auto;
  text-align: center;

  .function-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .function-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .function-text {
    display: inline-block;
    font-size: 18px;
    margin-top: 20px;
  }

  .function-content {
    width: 1400px;
    height: 471px;
    margin: 0 auto;
    margin-top: 57px;

    .content-top {
      width: 1400px;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
    }

    .content-title {
      width: 1400px;
      font-size: 18px;
      font-weight: bold;
    }

    .content {
      width: 1400px;
      position: relative;

      .content-left {
        width: 310px;
        text-align: right;
        position: absolute;

        h3 {
          font-size: 18px;
          font-weight: bold;
        }

        h4 {
          font-weight: 400;
          font-size: 14px;
          line-height: 24px;
        }
      }

      .left-1 {
        top: 75px;
        left: 75px;
      }

      .left-2{
        top: 200px;
        left: 15px;
      }
      
      .left-3{
        top: 335px;
        left: -10px;
      }

       .content-right {
        width: 310px;
        text-align: left;
        position: absolute;

        h3 {
          font-size: 18px;
          font-weight: bold;
        }

        h4 {
          font-weight: 400;
          font-size: 14px;
          line-height: 24px;
        }
      }

      .right-1 {
        top: 90px;
        left: 965px;
      }

      .right-2{
        top: 200px;
        left: 1065px;
      }
      
      .right-3{
        top: 320px;
        left: 1105px;
      }
    }
  }
}

.medicine-footer {
  width: 100%;
  height: 160px;
  margin-top: 145px;
  background: url('../../static/images/fiveG/bg(1).png');
  text-align: center;
  border-sizing: border-box;
  position: relative;
  z-index: 3;

  h3 {
    padding-top: 28px;
    font-size: 24px;
    line-height: 28px;
    color: #FFFFFF;
  }

  a {
    text-decoration: none;
    display: inline-block;
    width: 170px;
    height: 50px;
    margin: 24px auto;
    font-size: 18px;
    font-weight: bold;
    color: #FFFEFC;
    line-height: 50px;
    border: 1px solid #FFFEFC;
    border-radius: 4px;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/solutionProramme.vue